import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";

const useStyles = makeStyles(theme => ({
  absoluteWrapper: {
    position: "relative"
  },
  fileExtensionContainer: {
    height: "100%",
    textAlign: "center"
  },
  fileExtensionStyles: {
    top: "-1rem",
    left: "1rem",
    position: "absolute",
    color: "white",
    fontFamily: "sans-serif",
    fontSize: ".875rem",
    fontWeight: theme.typography.fontWeightLight,
    textTransform: "uppercase"
  },
  fileIconStyles: {
    color: theme.palette.primary.main,
    fontSize: "3.75rem"
  }
}));

const FileExtension = ({ filename = "" }) => {
  const {
    fileExtensionContainer,
    fileIconStyles,
    fileExtensionStyles,
    absoluteWrapper
  } = useStyles();
  return (
    <span className={fileExtensionContainer}>
      <span className={absoluteWrapper}>
        <InsertDriveFileIcon className={fileIconStyles} />
        <span className={fileExtensionStyles}>{filename.split(".").pop()}</span>
      </span>
      <Typography>{filename}</Typography>
    </span>
  );
};

export default FileExtension;
